// react and js
import { React } from "react";
import { useTranslation } from "react-i18next";

// mui
import { Typography, Link, Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

// components

// hooks

// i18n
import { localizeWebsiteUrl, DEFAULT_LANGUAGE } from "../i18n";

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function PublicFooter() {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
  const activeLang = i18n.language || DEFAULT_LANGUAGE;
  const websiteUrl = localizeWebsiteUrl(
    process.env.REACT_APP_URL_FRONTEND_WEBSITE,
    activeLang
  );
  const imprintUrl = localizeWebsiteUrl(
    process.env.REACT_APP_URL_FRONTEND_IMPRINT,
    activeLang
  );
  const privacyPolicyUrl = localizeWebsiteUrl(
    process.env.REACT_APP_URL_FRONTEND_PRIVACY_POLICY,
    activeLang
  );
  const termsUrl = localizeWebsiteUrl(
    process.env.REACT_APP_URL_FRONTEND_TERMS_AND_CONDITIONS,
    activeLang
  );
  const riskDisclosureNoticeUrl = localizeWebsiteUrl(
    process.env.REACT_APP_URL_FRONTEND_RISK_DISCLOSURE_NOTICE,
    activeLang
  );
  return (
    <Box>
      <Box
        sx={{
          textAlign: "center",
          mt: isDesktop === true ? "74vh" : "70vh",
          mb: -0.5,
        }}
      >
        <Typography variant="footerPublic" sx={{ color: "#737785" }}>
          {t("layouts.publicFooter.recaptchaPrefix")}&nbsp;
          <Link
            variant="footerPublicLink"
            underline="none"
            color="inherit"
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener"
            sx={{ fontWeight: "bold" }}
          >
            {t("layouts.publicFooter.privacyPolicy")}
          </Link>
          &nbsp;{t("layouts.publicFooter.and")}&nbsp;
          <Link
            variant="footerPublicLink"
            underline="none"
            color="inherit"
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noopener"
            sx={{ fontWeight: "bold" }}
          >
            {t("layouts.publicFooter.termsOfService")}
          </Link>
          &nbsp;{t("layouts.publicFooter.apply")}.
        </Typography>
      </Box>

      {isDesktop === true ? (
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <Typography variant="footerPublic" sx={{ color: "#737785" }}>
            <Link
              variant="footerPublicLink"
              underline="none"
              color="inherit"
              href={websiteUrl}
            >
              © {new Date().getFullYear()} {process.env.REACT_APP_NAME_LEGAL}
            </Link>
            &nbsp;&bull;&nbsp;
            <Link
              variant="footerPublicLink"
              underline="none"
              color="inherit"
              href={imprintUrl}
            >
              {t("layouts.publicFooter.imprint")}
            </Link>
            &nbsp;&bull;&nbsp;
            <Link
              variant="footerPublicLink"
              underline="none"
              color="inherit"
              href={privacyPolicyUrl}
            >
              {t("layouts.publicFooter.privacyPolicy")}
            </Link>
            &nbsp;&bull;&nbsp;
            <Link
              variant="footerPublicLink"
              underline="none"
              color="inherit"
              href={termsUrl}
            >
              {t("layouts.publicFooter.termsAndConditions")}
            </Link>
            {riskDisclosureNoticeUrl && (
              <>
                &nbsp;&bull;&nbsp;
                <Link
                  variant="footerPublicLink"
                  underline="none"
                  color="inherit"
                  href={riskDisclosureNoticeUrl}
                >
                  {t("layouts.publicFooter.riskDisclosureNotice")}
                </Link>
              </>
            )}
          </Typography>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography variant="footerPublic" sx={{ color: "#737785" }}>
              <Link
                variant="footerPublicLink"
                underline="none"
                color="inherit"
                href={websiteUrl}
              >
                © {new Date().getFullYear()} {process.env.REACT_APP_NAME_LEGAL}
              </Link>
              &nbsp;&bull;&nbsp;
              <Link
                variant="footerPublicLink"
                underline="none"
                color="inherit"
                href={imprintUrl}
              >
                {t("layouts.publicFooter.imprint")}
              </Link>
              &nbsp;&bull;&nbsp;
              <Link
                variant="footerPublicLink"
                underline="none"
                color="inherit"
                href={privacyPolicyUrl}
              >
                {t("layouts.publicFooter.privacyPolicy")}
              </Link>
            </Typography>
          </Box>

          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <Typography variant="footerPublic" sx={{ color: "#737785" }}>
              <Link
                variant="footerPublicLink"
                underline="none"
                color="inherit"
                href={termsUrl}
              >
                {t("layouts.publicFooter.termsAndConditions")}
              </Link>
              {riskDisclosureNoticeUrl && (
                <>
                  &nbsp;&bull;&nbsp;
                  <Link
                    variant="footerPublicLink"
                    underline="none"
                    color="inherit"
                    href={riskDisclosureNoticeUrl}
                  >
                    {t("layouts.publicFooter.riskDisclosureNotice")}
                  </Link>
                </>
              )}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
}
